/*
Auto-generated by: https://github.com/pmndrs/gltfjsx
Author: SebastianSosnowski (https://sketchfab.com/SebastianSosnowski)
License: CC-BY-4.0 (http://creativecommons.org/licenses/by/4.0/)
Source: https://sketchfab.com/3d-models/the-moon-9916fcec59f04b07b3e8d7f077dc3ded
Title: The Moon
*/

import React, { useEffect, useLayoutEffect, useRef, useState } from 'react'
import { useGLTF, useScroll } from '@react-three/drei'
import gsap from 'gsap'
import { useFrame } from '@react-three/fiber'
import { click } from '@testing-library/user-event/dist/click'

export function Moon(props) {
  const { nodes, materials } = useGLTF('/models/moon2/scene.gltf')

  const [active, setActive] = useState(true)



  const ref = useRef()
  const tl = useRef()
  const tl2 = useRef()

  const scroll = useScroll()

  let state = ''


  let currentScroll = 0;
 

  let aux = 0.00
  useFrame(()=>{  

      if(!active){
        scroll.el.scrollTo({top: currentScroll})
        
      }
   

    let _scroll = parseFloat(scroll.offset.toFixed(2))
    // console.log(_scroll)
  //   console.log(aux)
   
    if(_scroll > aux){
    
     

        if(scroll.offset > 0.51 && scroll.offset < 0.66){
          scroll.el.scrollTo({top: window.innerHeight * 2.67})
          currentScroll = window.innerHeight * 2.67
          setActive(false);
        }

   

    }
    if(_scroll < aux){
  
      if(scroll.offset < 0.8 && scroll.offset > 0.67){
        scroll.el.scrollTo({top: window.innerHeight * 2.67})
          currentScroll = window.innerHeight * 2.67
          setActive(false);
   
      }
      
    }

    if(_scroll === aux){
      // console.log('IDLE')
    }
    aux = _scroll;
    
    // // tl.current.pause()
    // if(scroll.offset > 0.51 && scroll.offset < 0.66){
    
    //   // scroll.el.scrollTo({top: window.innerHeight * 1.67})
    //   scroll.el.scrollTo({top: window.innerHeight * 2.67})
     
    // }
  
      tl.current.seek((scroll.offset / 4) * (tl.current.duration()))
  
    
    
  })

  // useEffect(() => {

  //   window.addEventListener("click", (evt)=>{
     
  //     // scroll.offset = 0.33
  //     tl.current.seek((0.33 / 4) * (tl.current.duration()))
  //     // scroll.el.scrollTo({top: window.innerHeight * 1.34})
  //     scroll.el.scrollTo({top: window.innerHeight * 2.67})
      
  //   });
  
  
  //   return () => {
  
  //     window.removeEventListener("click", ()=>{});
  
  //   };
  
  // }, []);

  useEffect(()=>{
   // console.log(active)
    if(!active){
      setTimeout(()=>{
        setActive(true)
      },1000)
    }
  },[active])

  useEffect(()=>{
    
      let rotate = props.call

      

     


     // console.log(rotate)
       
        // console.log(ref.current.rotation.x)

        // let rotate =+ props.call - 1;
        // console.log(rotate)

        gsap.to(ref.current.rotation, {duration:0.5, x:rotate, ease: "linear",})
  },[props.call])

  useLayoutEffect(()=>{
   
    tl.current = gsap.timeline({duration:12})
    tl.current.pause()
    // tl2.current = gsap.timeline({repeat:-1})
    // tl2.current.to(ref.current.rotation, {duration:10,y:6.4,ease: "linear",},0)

    // console.log(ref.current.rotation.y)

   

        tl.current.to(ref.current.rotation, {duration:1,y:1.4,ease: "linear",},0)
        tl.current.to(ref.current.position, {duration:1, y:10, z:90,ease: "linear",},0)
        tl.current.to(ref.current.scale, {duration:1, x:1.5, y:1.5, z:1.5,ease: "linear",},0)

        tl.current.to(ref.current.rotation, {duration:1,y:2.8,ease: "linear", onComplete:()=>{}}, 1)
        tl.current.to(ref.current.position, {duration:1, y:120, z:0,ease: "linear", onComplete:()=>{}},1)
        tl.current.to(ref.current.scale, {duration:1, x:2, y:2, z:2,ease: "linear", onComplete:()=>{}},1)


        tl.current.to(ref.current.rotation, {duration:1,y:3.8,ease: "linear", onComplete:()=>{}}, 2)
        tl.current.to(ref.current.position, {duration:1, y:200, x:0, z:0,ease: "linear", onComplete:()=>{}},2)
        tl.current.to(ref.current.scale, {duration:1, x:3, y:3, z:3, ease: "linear", onComplete:()=>{}},2)


        //estas 3 lineas estaban comentadas
      //   tl.current.to(ref.current.scale, {duration:1,x:0.1, y:0.1, z:0.1,ease: "linear"},5)

     

       //  tl.current.to(ref.current.scale, {duration:1, x:0.5, y:0.5, z:0.5,ease: "linear", delay:9, onComplete:()=>{console.log("2") }},2)
     
        
        // tl.current.fromTo(".services-frame", { opacity: 0 }, { opacity: 1, duration: 1 }, 2);
    return () => {}

  },[])

//   useEffect(() => {
//     // const onScroll = () => setOffset(window.scrollY);
//     // clean up code
//     window.removeEventListener('click', ()=>{});
//     window.addEventListener('click', (evt)=>{
//         console.log(evt)
//     }, { passive: true });

    


//     return () => window.removeEventListener('click', ()=>{});
// }, []);


  return (
    <group {...props} dispose={null} ref={ref}>
      <group rotation={[-Math.PI / 2, 0, 0]}>
        <mesh
          castShadow
          receiveShadow
          geometry={nodes.defaultMaterial.geometry}
          material={materials.Material__50}
          scale={[50,50,50]}
          rotation={[1, 1, 1]}
        />
      </group>
    </group>
  )
}

useGLTF.preload('/models/moon2/scene.gltf')
